const AttributeDesignSystemComponents = 'data-design-system-components';
const AttributeElementProperties = 'data-fs-properties-schema';

interface IdentityProps {
  [AttributeDesignSystemComponents]: string;
  [AttributeElementProperties]: string;
}

export function identifyComponent<P extends object>(
  componentName: string,
  restProps?: P,
): IdentityProps {
  const restComponents = (restProps as Partial<IdentityProps>)?.[AttributeDesignSystemComponents];
  const restElementProps = (restProps as Partial<IdentityProps>)?.[AttributeElementProperties];
  const components = restComponents != null ? JSON.parse(restComponents) : [];
  const elementProps = restElementProps != null ? JSON.parse(restElementProps) : {};
  const componentSet = new Set(components);
  return {
    [AttributeDesignSystemComponents]: JSON.stringify([...componentSet.add(componentName).keys()]),
    [AttributeElementProperties]: JSON.stringify({
      ...elementProps,
      [AttributeDesignSystemComponents]: 'strs',
    }),
  };
}
